import React, {PureComponent} from 'react';
import {
  Col,
  Row,
  Grid,
} from 'react-bootstrap';
import './SchedulePage.css';

class SchedulePage extends PureComponent {

  render() {

    return (
      <div>
        <Grid>
            <Row>
              <Col sm={8} smOffset={2} className="SchedulePage-events">
                <event>
                  <name>Santa Fe Apprentice Scenes</name>
                  <date>Summer 2017</date>
                </event>
                <event>
                  <name>CCPA Operafest</name>
                  <date>Fall 2017</date>
                </event>
                <event>
                  <name>Forte Chicago La La Lady Show</name>
                  <date>Fall 2017</date>
                </event>
                <event>
                  <name>Distant Flight of Birds, Links Hall</name>
                  <date>Winter 2017</date>
                </event>
                <event>
                  <name>Cendrillon, North Park Opera</name>
                  <event>Spring 2018</event>
                </event>
              </Col>
            </Row>
        </Grid>
      </div>
    );
  }
}

export default SchedulePage;



// WEBPACK FOOTER //
// ./src/containers/SchedulePage.jsx